import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Moment = ({
  id,
  title,
  subtitle,
  type,
  icon,
  className,
  goToMomentDetail,
  descriptionClassName,
  timelineIconClassName
}) => {

  return (
    <div
      id={id}
      className={`${className} ${styles.timelineMoment}`}>
      <div
        className={`${timelineIconClassName} ${styles.timelineMomentIcon}`}
        title={`${title} - ${subtitle}`}
        onClick={() => { goToMomentDetail(id) }}
      >
        <img src={icon} alt={title} />
      </div>
      <div className={`${descriptionClassName} ${styles.timelineMomentWrapperTitle}`}>
        {title && <div className={styles.timelineMomentTitle} dangerouslySetInnerHTML={{ __html: title }} />}
        {subtitle && <div className={styles.timelineMomentSubTitle} dangerouslySetInnerHTML={{ __html: subtitle }}/>}
      </div>
    </div>
  );
}

Moment.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  timelineIconClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  goToMomentDetail: PropTypes.func,
};

export default Moment;